import { TenantFeatureSettingWorkFlowType } from "./tenant-workflows-types";

const cefTenantFeatureSettingTypes = [
    TenantFeatureSettingWorkFlowType.BankAccountChangeEntityFramework,
    TenantFeatureSettingWorkFlowType.CashDiscCodeChangeEntityFramework,
    TenantFeatureSettingWorkFlowType.FixedAssetPostingProfilesChangeEntityFramework,
    TenantFeatureSettingWorkFlowType.FixedAssetsChangeEntityFramework,
    TenantFeatureSettingWorkFlowType.MainDimensionChangeEntityFramework,
    TenantFeatureSettingWorkFlowType.MiscChargeChangeEntityFramework,
    TenantFeatureSettingWorkFlowType.PaymentInformationChangeEntityFramework,
    TenantFeatureSettingWorkFlowType.PaymentTermChangeEntityFramework,
    TenantFeatureSettingWorkFlowType.ProductReceiptChangeEntityFramework,
    TenantFeatureSettingWorkFlowType.ProjectActivitiesChangeEntityFramework,
    TenantFeatureSettingWorkFlowType.ProjectDefaultLinePropertiesChangeEntityFramework,
    TenantFeatureSettingWorkFlowType.ProjectLinePropertiesChangeEntityFramework,
    TenantFeatureSettingWorkFlowType.PurchaseAgreementHeadersChangeEntityFramework,
    TenantFeatureSettingWorkFlowType.PurchaseAgreementLinesChangeEntityFramework,
    TenantFeatureSettingWorkFlowType.PurchaseOrderChangeEntityFramework,
    TenantFeatureSettingWorkFlowType.SalesTaxChangeEntityFramework,
    TenantFeatureSettingWorkFlowType.VendorChangeEntityFramework,
];

export default cefTenantFeatureSettingTypes;
